<!-- pipeline管理 -->
<template>
    <basicContainer>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="跟进" name="1"></el-tab-pane>
            <el-tab-pane label="签约" name="2"></el-tab-pane>
        </el-tabs>
        <avue-crud ref="avueCrud" :data="tableData" :option="option" v-model="form" :table-loading="TABLE_LOADING" :page.sync="TABLE_PAGE" @search-change="SEARCH_CHANGE" @refresh-change="TABLE_REFRESH" @search-reset="SEARCH_RESET" @cell-click="CELL_CLICK" @selection-change="SELECTION_CHANGE" @sort-change="SORT_CHANGE" @size-change="SIZE_CHANGE" @current-change="CURRENT_CHANGE" :before-open="beforeOpen" :before-close="beforeClose" @row-update="rowUpdate" @row-save="rowSave" @row-del="rowDel">
            <template slot="menuLeft" v-if="isshowadd">
                <el-button type="primary" size="small" @click="rowAdd">新增</el-button>
            </template>
            <template v-slot:menu="{type,size,row}">
                <el-button size="small" type="text" icon="el-icon-view" @click.stop="view(row)">查看</el-button>
                <el-button size="small" type="text" icon="el-icon-edit" @click.stop="edit(row)">编辑</el-button>
            </template>
        </avue-crud>
    </basicContainer>
</template>

<script>
import {
  getDictionary
} from '@/businessManagement/utils/jwTools.js'
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
export default {
  name: 'PipelineManagement',
  mixins: [crudPageMinix],
  data() {
    return {
      isshowadd: false,
      activeName: '1',
      option: {
        stripe: true,
        border: true,
        page: true,
        selection: false,
        index: true,
        indexLabel: '序号',
        tip: false,
        align: 'left',
        menuAlign: 'center',
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 170,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        menuWidth: 150,
        column: [
          {
            label: '项目编号',
            prop: 'xm_bh',
            search: true,
            searchLabelWidth: 100,
            minWidth: 120
          },
          {
            label: '项目名称',
            prop: 'xm_mc',
            search: true,
            overHidden: true,
            searchLabelWidth: 100,
            minWidth: 150
          },
          {
            label: '客户名称',
            prop: 'kh_mc',
            search: true,
            overHidden: true,
            searchLabelWidth: 100,
            minWidth: 150
          },
          {
            label: '项目销售状态',
            prop: 'xm_zt',
            search: true,
            searchLabelWidth: 100,
            type: 'select',
            dicData: [],
            props: {
              label: 'label',
              value: 'label'
            },
            hide: true,
            minWidth: 110
          },
          {
            label: '项目销售状态',
            prop: 'xm_ztmc',
            minWidth: 110
          },
          {
            label: '是否提前进场',
            prop: 'sftqjc',
            search: true,
            searchLabelWidth: 100,
            type: 'select',
            dicData: [],
            minWidth: 110
          },
          {
            label: '销售经理',
            prop: 'xs',
            search: true,
            searchLabelWidth: 100,
            minWidth: 80
          },
          {
            label: '最新销售情况',
            prop: 'zxxsqk',
            minWidth: 150,
            hide: true
          }

        ]
      },
      form: {},
      tableData: []
    }
  },
  mounted() {
    this.loadData()
    getDictionary('XMZT').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'xm_zt', 'prop')
        ],
        'dicData',
        dic
      )
    })
    // 判断角色
    let LoginName = this.$store.getters.userInfo.subject.roleList.map(
      (item) => item.roleCode
    )
    if (
      LoginName.indexOf('2384044025' || '2021920789') !== -1
    ) {
      this.isshowadd = true
    }
    getDictionary('SFXX').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'sftqjc', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('FROMID').then((dic) => {
      dic.map(item => {
        if (item.value == 'pipeline') {
          this.formid = item.label
        }
      })
    })
  },
  methods: {
    handleClick(tab, event) {
      this.loadData()
    },
    loadData(
      TABLE_PAGE = this.TABLE_PAGE,
      QUERY_CONDITIONS = this.QUERY_CONDITIONS,
      TABLE_ORDER = this.TABLE_ORDER,
      done,
      tabNum = this.activeName
    ) {
      this.TABLE_LOADING = true // 表格转圈
      this.QUERY_CONDITIONS.tab = tabNum || 1
      this.$http
        .post('/PipelineManage/queryHzbx',
          QUERY_CONDITIONS
          , {
            params: {
              pageNum: TABLE_PAGE.currentPage,
              pageSize: TABLE_PAGE.pageSize
            }
          })
        .then((response) => {
          this.RELOAD_CRUD(response.data.records)
          this.TABLE_PAGE.total =
                        response.data.total || response.data.records.length
          this.SELECT_LIST = []
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          this.TABLE_LOADING = false // 表格转圈
          typeof done === 'function' && done()
        })
    },
    view(row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: row.processInstanceId,
          taskId: null,
          formId: '2dd3d69da4214d06bc43abafb9b2c68a',
          pageKey: 'VIEW'
        }
      })
    },
    edit(row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: row.processInstanceId,
          taskId: null,
          formId: '2dd3d69da4214d06bc43abafb9b2c68a',
          pageKey: 'DO'
        }
      })
    },
    rowAdd() {
      this.$router.push('/applyForm?businessKey=&processInstanceId&taskId&formId=2dd3d69da4214d06bc43abafb9b2c68a&pageKey=DO')
    }
  }
}
</script>

